<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        v-for="(antecedent, index) in model.questionnaireAttachments"
        :key="index"
      >
        <h3 align="left" class="mb-2">{{ antecedent.name }}:</h3>
        <v-row justify="center" :dense="dense">
          <v-col
            v-for="(questions, subindex) in antecedent.questions"
            :key="subindex"
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
            cols="12"
            :md="calculeCols(antecedent.questions, questions)"
          >
            <validation-provider
              v-slot="{ errors, invalid, touched }"
              :name="questions.name"
              :rules="requiredValidation(questions.required)"
            >
              <v-col v-if="questions.typeAnswer == $cnst.ANSWER_TYPE_OPEN">
                <v-text-field
                  :label="questions.name"
                  v-model="questions.answerOpen"
                  :error-messages="errors"
                  :disabled="isViewDetailsForm"
                  :counter="200"
                  clearable
                  :clear-icon="$cnst.CLEAR_ICON"
                  :dense="dense"
                >
                  <v-icon
                    slot="append"
                    :color="touched && invalid ? 'error' : ''"
                  >
                    {{ touched && invalid ? "mdi-alert" : "" }}
                  </v-icon>
                </v-text-field>
              </v-col>

              <v-col v-if="questions.typeAnswer == $cnst.ANSWER_TYPE_CLOSED">
                <div
                  v-if="questions.typeData == $cnst.ANSWER_TYPE_DATA_CHECKBOX"
                >
                  <label> {{ questions.name }}</label>
                  <v-row dense>
                    <v-col
                      cols="auto"
                      v-for="(answer, subindexans) in questions.answers"
                      :key="subindexans"
                    >
                    
                    </v-col>
                  </v-row>
                </div>

                <v-autocomplete
                  v-else
                  :label="questions.name"
                  :items="questions.answers"
                  v-model="questions.answerClosed"
                  :error-messages="errors"
                  item-text="name"
                  item-value="idAnswer"
                  :disabled="isViewDetailsForm"
                  clearable
                  :clear-icon="$cnst.CLEAR_ICON"
                  no-data-text="Sin resultados disponibles"
                  :dense="dense"
                >
                  <v-icon
                    slot="append"
                    :color="touched && invalid ? 'error' : ''"
                  >
                    {{ touched && invalid ? "mdi-alert" : "" }}
                  </v-icon>
                </v-autocomplete>
              </v-col>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import ClockSelected from "@/app/components/colposcopy/Clock.vue";

export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
    cols: Number,
  },
  data() {
    return {
      dense: true,
      selectedAnswers: [],
      answers: [
        { id: 1, label: "1" },
        { id: 2, label: "2" },
        { id: 3, label: "3" },
        { id: 4, label: "4" },
        { id: 5, label: "5" },
        { id: 6, label: "6" },
        { id: 7, label: "7" },
        { id: 8, label: "8" },
        { id: 9, label: "9" },
        { id: 10, label: "10" },
        { id: 11, label: "11" },
        { id: 12, label: "12" },
      ],
    };
  },
  components: {
    ValidationProvider,
    ClockSelected,

  },
  methods: {
    calculeCols(cuantityQuestions, question) {
      switch (cuantityQuestions) {
        case 1:
          return "12";
        case 2:
          return "6";
        default:
          return "4";
      }
    },
    requiredValidation(validation) {
      if (validation) {
        return "required|max:200";
      } else {
        return "max:200";
      }
    },
    getItemStyle(index) {
      const angle = ((index / this.answers.length) * 360)-90;
      const radius = 100; 
      const x = radius * Math.cos((angle * Math.PI) / 180);
      const y = radius * Math.sin((angle * Math.PI) / 180);
      return {
        transform: `translate(${x}px, ${y}px)`,
      };
    },
  },
};
</script>
<style>
.circle-container {
  position: relative;
  margin-top: 90px !important;
  width: 200px;
  height: 110px;
  /* height: 240px; */
  margin: auto;
  /* display: flex; */
  /* align-items: left; */
}
/* .circle-container {
  position: relative;
  width: 200px; 
  height: 240px; 
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: left;
} */

.circle-item {
  position: absolute;
  margin-left: 50%;

  /* top: 50%; */
  /* left: %; */
  /* transform-origin: right !important; */
}
</style>
